import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b540afd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-5" }
const _hoisted_3 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_4 = { class: "w-max-content col-lg-2" }
const _hoisted_5 = { class: "col-lg-10" }
const _hoisted_6 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_7 = { class: "w-max-content col-lg-2" }
const _hoisted_8 = { class: "col-lg-10" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_12 = { class: "w-max-content col-lg-2" }
const _hoisted_13 = { class: "col-lg-10" }
const _hoisted_14 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_15 = { class: "w-max-content col-lg-2" }
const _hoisted_16 = { class: "col-lg-10" }
const _hoisted_17 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_18 = { class: "w-max-content col-lg-2" }
const _hoisted_19 = { class: "col-lg-10 text-break" }
const _hoisted_20 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_21 = { class: "w-max-content col-lg-2" }
const _hoisted_22 = { class: "col-lg-10" }
const _hoisted_23 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_24 = { class: "w-max-content col-lg-2" }
const _hoisted_25 = { class: "col-lg-10" }
const _hoisted_26 = { class: "d-flex justify-content-center" }

import { computed, PropType } from 'vue'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object as PropType<{
    management_no: string | number
    family_name: string
    given_name: string
    family_name_kana: string
    given_name_kana: string
    department_name: string
    email: string
    birthday: string
    institution: string
    job_type_parent: string
    job_type_child: string
    enrollment_start_period: string
    status: number
    phone_number_1: string
    phone_number_2: string
    phone_number_3: string
  }>,
},
  setup(__props) {

const props = __props

const router = useRouter()


const phoneNumber = computed(() =>
  props.data?.phone_number_1 || props.data?.phone_number_2 || props.data?.phone_number_3
    ? props.data?.phone_number_1 + '-' + props.data?.phone_number_2 + '-' + props.data?.phone_number_3
    : ''
)

const backToList = () => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/community-users?management_no=desc`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('basicInformation')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(translate)('managementNo')), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.data.management_no), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('nameKanji')), 1),
      _createElementVNode("div", _hoisted_8, [
        _createTextVNode(_toDisplayString(__props.data?.family_name + ' ' + __props.data?.given_name), 1),
        (__props.data.status === 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(translate)('SO10user30')), 1))
          : _createCommentVNode("", true),
        (__props.data.status === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(translate)('OE12pause')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(translate)('nameKatakana')), 1),
      _createElementVNode("div", _hoisted_13, _toDisplayString(__props.data?.family_name_kana + ' ' + __props.data?.given_name_kana), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(translate)('OE20belongs')), 1),
      _createElementVNode("div", _hoisted_16, _toDisplayString(__props.data?.department_name), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('email')), 1),
      _createElementVNode("div", _hoisted_19, _toDisplayString(__props.data?.email), 1)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
      _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(dayjs)(__props.data?.birthday).format('YYYY/MM/DD')), 1)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(translate)('PhoneNumber')), 1),
      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(phoneNumber)), 1)
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(Button, {
        title: _unref(translate)('back'),
        type: 'secondary',
        onClick: backToList
      }, null, 8, ["title"])
    ])
  ]))
}
}

})